/** Перенос `domain/models/app_package_info/app_package_info.dart`. */

import { fullVersionModelFromBuild, type FullVersionModel } from '@/domain/models/versionModel';

export interface AppPackageInfo {
  readonly version: FullVersionModel;
  readonly packageName: string;
  readonly buildSignature: string;
  readonly extra: Record<string, unknown>;
  readonly updateTime: Date | null;
  readonly installTime: Date | null;
  readonly installerStore: string | null;
}

/** `applicationId` из `android/app/build.gradle` — в вебе его взять неоткуда. */
const PACKAGE_NAME = 'com.example.ai_live_porters';

/**
 * Замена `AppPackageInfo.fromPackageInfo`: package_info_plus удалён вместе с
 * остальной Android-частью. Версия и номер сборки подставляются Vite —
 * `__APP_VERSION__` из package.json (тот же `major.minor.patch`, что был в
 * pubspec.yaml, чтобы сравнение с `app.version` конфигурации не изменилось)
 * и `__BUILD_NUMBER__` из переменной окружения BUILD_NUMBER.
 *
 * Форма модели оставлена прежней: поля, которых в браузере не существует
 * (подпись сборки, время установки и обновления, магазин), остаются пустыми —
 * приложение всё равно читает только `version`.
 */
export function appPackageInfoFromBuild(): AppPackageInfo {
  return {
    version: fullVersionModelFromBuild(__APP_VERSION__, __BUILD_NUMBER__),
    packageName: PACKAGE_NAME,
    buildSignature: '',
    extra: {},
    updateTime: null,
    installTime: null,
    installerStore: null,
  };
}
